/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

/*
    Main 'Add to cart' (ATC) form
*/
// window.onSubmitAtcForm = async (form, event) => {
//     event.preventDefault()

//     const btn = form.querySelector('.btn-atc')

//     btn.innerHTML = `
//         <div class="spinner-border spinner-border-sm" role="status">
//             <span class="visually-hidden">Loading...</span>
//         </div>
//     `

//     form.classList.add('loading')

//     const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })

//     form.classList.remove('loading')
//     btn.innerHTML = window.theme.product.addedToCart

//     setTimeout(() => {
//         btn.innerHTML = btn.dataset.textAddToCart
//     }, 2000)

//     window.refreshCartContents(response)

//     if (btn.hasAttribute('data-upsell-modal')) return
//     if (btn.closest('.modal')) return

//     bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
// }

window.onSubmitAtcForm = async (form, event) => {
    event.preventDefault();

    const modelBtn = form.querySelector('.model_product_atc');
    const defaultBtn = form.querySelector('.btn-atc');

    // CONDITION: if model_product_atc exists → run multiple variants add-to-cart
    if (modelBtn) {
        modelBtn.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `;

        form.classList.add('loading');

        // Get all active variant inputs inside this product form
        const variantInputs = modelBtn.closest("#product-content").querySelectorAll(".model_variants_list.active .product_model_id input");

        // Build items array for fetch
        const items = [];
        variantInputs.forEach(input => {
            items.push({
                id: input.id,               // variant ID
                quantity: parseInt(input.value) || 1
            });
        });

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ items })
            });

            const data = await response.json();

            form.classList.remove('loading');
            modelBtn.innerHTML = window.theme.product.addedToCart;
            
            setTimeout(() => {
                modelBtn.innerHTML = window.theme.product.addToCart || "Add to cart";
            }, 2000);

            window.refreshCartContents(data);

            if (!modelBtn.hasAttribute('data-upsell-modal') && !modelBtn.closest('.modal')) {
                bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show();
            }

        } catch (error) {
            form.classList.remove('loading');
            console.error('Add to cart failed:', error);
            alert('Something went wrong. Please try again.');
        }

    } else if (defaultBtn) {
        // DEFAULT behavior for normal single-product add-to-cart
        defaultBtn.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `;

        form.classList.add('loading');

        const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });

        form.classList.remove('loading');
        defaultBtn.innerHTML = window.theme.product.addedToCart;

        setTimeout(() => {
            defaultBtn.innerHTML = defaultBtn.dataset.textAddToCart;
        }, 2000);

        window.refreshCartContents(await response.json());

        if (defaultBtn.hasAttribute('data-upsell-modal')) return;
        if (defaultBtn.closest('.modal')) return;

        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show();
    }
};


/*
    'Add to cart' form based on variant
*/
window.onClickAtcFormVariant = async (btn, event) => {
    const form = btn.closest('form')
    form.querySelector('[name="id"]').value = btn.dataset.variantId

    window.onSubmitAtcForm(form, event)
}

/*
    Product options selector - Listen for change events
    Works only in the product page
*/
window.onChangeProductOption = async (input) => {
    const selectedOptions = []

    input.closest('form').querySelectorAll('.product-option').forEach(elem => {
        if (elem.type === 'radio') {
            if (elem.checked) {
                selectedOptions.push(elem.value)
            }
        } else {
            selectedOptions.push(elem.value)
        }
    })

    const selectedVariant = window.productVariants.find(variant =>
        JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    )

    console.log(selectedVariant)

    const btn = input.closest('form').querySelector('.btn-atc')

    if (selectedVariant) {
        input.closest('form').querySelector('[name="id"]').value = selectedVariant.id

        if (selectedVariant.available) {
            btn.disabled = false
            btn.innerHTML = window.theme.product.addToCart
        } else {
            btn.disabled = true
            btn.innerHTML = window.theme.product.soldOut
        }

        if (selectedVariant.compare_at_price) {
            let price_html = ``;

            if (selectedVariant.compare_at_price > selectedVariant.price) {
                price_html += `
                    <span class="product-price-compare text-muted me-3">
                        <span class="visually-hidden">
                            ${window.theme.product.priceFrom} &nbsp;
                        </span>
                        <s>
                            MSRP: ${Shopify.formatMoney(selectedVariant.compare_at_price)}
                        </s>
                    </span>
                `;
            }

            price_html += `
                <span class="product-price-final">
                    <span class="visually-hidden">
                        ${window.theme.product.priceSale} &nbsp;
                    </span>
                    Your Price: ${Shopify.formatMoney(selectedVariant.price)}
                </span>
            `;

            input.closest('#product-content').querySelector('.product-price').innerHTML = price_html;
            
            // input.closest('#product-content').querySelector('.product-price').innerHTML = `
             
            //     <span class="product-price-compare text-muted me-3">
            //         <span class="visually-hidden">
            //             ${window.theme.product.priceFrom} &nbsp;
            //         </span>
            //         <s>
            //             MSRP: ${Shopify.formatMoney(selectedVariant.compare_at_price)}
            //         </s>
            //     </span>
        
            //     <span class="product-price-final">
            //         <span class="visually-hidden">
            //             ${window.theme.product.priceSale} &nbsp;
            //         </span>
            //         Your Price: ${Shopify.formatMoney(selectedVariant.price)}
            //     </span>
            // `
        } else {
            let isCustomer = input.closest('#product-content').querySelector('.product-price').dataset.customer;
            input.closest('#product-content').querySelector('.product-price').innerHTML = `
                <span class="product-price-final">
                    ${isCustomer == 'true' ? "Your Price" : "MSRP" }: ${Shopify.formatMoney(selectedVariant.price)}
                </span>
            `
        }
        if (selectedVariant.available && selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
            input.closest('#product-content').querySelector('.product-price').insertAdjacentHTML('beforeend', `
                <span class="price-badge-sale badge">
                    ${window.theme.product.save}: ${Math.round((1 - (selectedVariant.price / selectedVariant.compare_at_price)) * 100)}%
                </span>    
            `)
        } else if (!selectedVariant.available) {
            input.closest('#product-content').querySelector('.product-price').insertAdjacentHTML('beforeend', `
                <span class="price-badge-sold-out badge">
                    ${window.theme.product.soldOut}
                </span>
            `)
        }

        const url = new URL(window.location)
        url.searchParams.set('variant', selectedVariant.id)
        window.history.replaceState({}, '', url)

        const customEvent = new CustomEvent('variantChange.ecomify.product', {
            detail: selectedVariant
        })
        window.dispatchEvent(customEvent)
    } else {
        btn.disabled = true
        btn.innerHTML = window.theme.product.unavailable
    }

    if (input.closest('.color-swatches')) {
        input.closest('form').querySelector('.color-swatches-title').textContent = input.value
    }

    if (affirm) {
        document.querySelectorAll('.affirm-as-low-as').forEach(elem => {
            elem.setAttribute('data-amount', selectedVariant.price);
        })
        affirm.ui.refresh()
    }
}

// Product Item - Handle variant change
window.onChangeProductItemVariant = (select, event) => {
    if (select.options[select.selectedIndex].dataset.variantImage?.length) {
        select.closest('.product-item').querySelector('.product-item-img').src =
            select.options[select.selectedIndex].dataset.variantImage
    }

    const compareAtPrice = select.options[select.selectedIndex].dataset.compareAtPrice
    const price = select.options[select.selectedIndex].dataset.price

    if (compareAtPrice.length) {
        select.closest('.product-item').querySelector('.product-item-price').innerHTML = `
            <span class="product-item-price-compare text-muted me-1">
                <span class="visually-hidden">
                    ${window.theme.product.priceFrom} &nbsp;
                </span>
                <s>
                    ${Shopify.formatMoney(compareAtPrice)}
                </s>
            </span>
            <span class="product-item-price-final">
                <span class="visually-hidden">
                    ${window.theme.product.priceSale} &nbsp;
                </span>
                ${Shopify.formatMoney(price)}
            </span>
        `
    } else {
        select.closest('.product-item').querySelector('.product-item-price').innerHTML = `
            <span class="product-item-price-final">
                ${Shopify.formatMoney(price)}
            </span>
        `
    }
}

/*
    'Buy it now' button
*/
window.onClickBuyBtn = (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
    const form = btn.closest('form')
    const variantId = form.querySelector('[name="id"]').value
    const qty = Number(form.querySelector('input[name="quantity"]').value || 1)
    window.location.href = `/cart/${variantId}:${qty}`
}

/*
    Product Gallery
*/
const initProductGallery = () => {
    const wrapper = document.querySelector('#product-gallery')

    if (!wrapper) return

    const main = new Splide(wrapper.querySelector('.main-splide'), {
        start: Number(wrapper.dataset.start),
        rewind: true,
        arrows: true,
        rewindByDrag: true,
        pagination: false
    })

    const totalSlides = wrapper.querySelectorAll('.main-splide .splide__slide').length

    const thumbs = new Splide(wrapper.querySelector('.thumbs-splide'), {
        start: Number(wrapper.dataset.start),
        gap: '.5rem',
        rewind: true,
        rewindByDrag: true,
        pagination: false,
        isNavigation: true,
        focus: totalSlides > 5 ? 'center' : 0,
        mediaQuery: 'min',
        breakpoints: {
            0: { perPage: 5, arrows: true },
            576: { perPage: 5, arrows: true },
            768: { perPage: 5, arrows: true },
            992: { perPage: 5, arrows: true },
            1200: { perPage: 5, arrows: true },
            1400: { perPage: 5, arrows: true }
        }
    })

    main.on('move', (newIndex, prevIndex) => {
        const iframe = wrapper.querySelector(`.splide__slide:nth-child(${prevIndex + 1}) iframe`)
        const video = wrapper.querySelector(`.splide__slide:nth-child(${prevIndex + 1}) video`)
        if (iframe) {
            // eslint-disable-next-line no-self-assign
            iframe.src = iframe.src
        }
        if (video) {
            video.pause()
        }
    })

    window.addEventListener('variantChange.ecomify.product', (event) => {
        const selectedVariant = event.detail

        if (selectedVariant.featured_media) {
            main.go(selectedVariant.featured_media.position - 1)
        }
    }, false)

    main.sync(thumbs)
    main.mount()
    thumbs.mount()

    if (window.matchMedia('(min-width: 992px)').matches) {
        const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top').clientHeight || 0
        wrapper.style.position = 'sticky'
        wrapper.style.top = `${navbarHeight + 20}px`
        wrapper.style.zIndex = '1'
    }

    // eslint-disable-next-line no-unused-vars
    const lightbox = GLightbox({
        selector: '[data-gallery="product-gallery"]',
        videosWidth: '1290px',
        loop: true
    })

    lightbox.on('slide_changed', ({ prev, current }) => {
        main.go(current.index)
    })
}
initProductGallery()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#product-gallery')) {
        initProductGallery()
    }
})

/*
    Inventory Bar
*/
const initInventoryBar = () => {
    const wrapper = document.querySelector('#inventory-bar')

    if (!wrapper) return

    const progressBar = wrapper.querySelector('.progress-bar')

    setTimeout(() => {
        progressBar.style.width = progressBar.dataset.width
    }, 250)
}
initInventoryBar()

window.addEventListener('variantChange.ecomify.product', async (event) => {
    const wrapper = document.querySelector('#inventory-bar')

    if (!wrapper) return

    wrapper.style.opacity = '.25'

    const respoonse = await fetch(window.location.href)
    const text = await respoonse.text()
    const newDocument = new DOMParser().parseFromString(text, 'text/html')

    document.querySelector('#inventory-bar')
        ?.replaceWith(newDocument.querySelector('#inventory-bar'))

    initInventoryBar()
})

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#inventory-bar')) {
        initInventoryBar()
    }
})

/*
    Upsell modal
*/
const initUpsellModal = () => {
    const btn = document.querySelector('.btn-atc[data-upsell-modal]')

    if (!btn) return

    btn.addEventListener('click', () => {
        const modal = bootstrap.Modal.getOrCreateInstance('#product-upsell-modal')
        modal.show()
    })

    document.querySelectorAll('#product-upsell-modal .btn-atc').forEach(btn => {
        btn.addEventListener('click', () => {
            const footerBtn = document.querySelector('#product-upsell-modal .modal-footer .btn')
            footerBtn.classList.remove(footerBtn.dataset.defaultClass)
            footerBtn.classList.add(footerBtn.dataset.activeClass)
        })
    })

    document.querySelector('#product-upsell-modal').addEventListener('hidden.bs.modal', () => {
        const offcanvasCart = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart')
        offcanvasCart.show()
    })
}
initUpsellModal()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#product-upsell-modal')) {
        initUpsellModal()
    }
})

/*
    Bought Together
*/
const initBoughtTogether = () => {
    if (!document.querySelector('#product-bought-together')) return

    const setTotalPrice = () => {
        let totalCompareAtPrice = 0
        let totalPrice = 0

        document.querySelectorAll('#product-bought-together .product-item-price').forEach(elem => {
            if (elem.closest('.product-item').querySelector('.bought-together-check:checked')) {
                totalCompareAtPrice += elem.dataset.compareAtPrice.length ? Number(elem.dataset.compareAtPrice) : Number(elem.dataset.price)
                totalPrice += Number(elem.dataset.price)
            }
        })

        const totalElem = document.querySelector('#bought-together-total')

        if (totalCompareAtPrice > totalPrice) {
            totalElem.innerHTML = `
                ${totalElem.dataset.textTotalPrice}: 
                <span class="bought-together-total-compare-price text-muted me-2">
                    <span class="visually-hidden">
                        ${window.theme.product.priceFrom} &nbsp;
                    </span>
                    <s>
                        ${Shopify.formatMoney(totalCompareAtPrice)}
                    </s>
                </span>
                <span class="bought-together-total-price text-success">
                    <span class="visually-hidden">
                        ${window.theme.product.priceSale} &nbsp;
                    </span>
                    ${Shopify.formatMoney(totalPrice)}
                </span>
            `
        } else {
            totalElem.innerHTML = `
                ${totalElem.dataset.textTotalPrice}: 
                <span class="bought-together-total-price">
                    ${Shopify.formatMoney(totalPrice)}
                </span>
            `
        }
    }

    document.querySelectorAll('.bought-together-check').forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                checkbox.closest('.product-item').style.opacity = '1'
            } else {
                checkbox.closest('.product-item').style.opacity = '.5'
            }

            if (document.querySelector('.bought-together-check:checked')) {
                document.querySelector('#bought-together-atc').disabled = false
            } else {
                document.querySelector('#bought-together-atc').disabled = true
            }

            setTotalPrice()
        })
    })

    document.querySelectorAll('#product-bought-together select[name="id"]').forEach(select => {
        select.addEventListener('change', () => {
            const compareAtPrice = select.options[select.selectedIndex].dataset.compareAtPrice
            const price = select.options[select.selectedIndex].dataset.price

            select.closest('.product-item').querySelector('.product-item-price')
                .setAttribute('data-compare-at-price', compareAtPrice)
            select.closest('.product-item').querySelector('.product-item-price')
                .setAttribute('data-price', price)

            setTotalPrice()
        })
    })

    document.querySelector('#bought-together-atc').addEventListener('click', async (e) => {
        const btn = e.target

        btn.style.width = btn.clientWidth + 4 + 'px'
        btn.innerHTML = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `

        const items = []

        document.querySelectorAll('#product-bought-together .product-item').forEach(elem => {
            if (elem.querySelector('.bought-together-check:checked')) {
                items.push({
                    id: Number(elem.querySelector('[name="id"]').value),
                    quantity: 1
                })
            }
        })

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
        })

        btn.innerHTML = window.theme.product.addedToCart

        setTimeout(() => {
            btn.innerHTML = btn.dataset.textAddToCart
        }, 2000)

        window.refreshCartContents(response)

        bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show()
    })
}
initBoughtTogether()

/*
    Qty Breaks
*/
const initQtyBreaks = () => {
    document.querySelectorAll('[name="product-qty-breaks"]').forEach(radio => {
        radio.addEventListener('change', () => {
            const qty = Number(radio.dataset.qty)

            const qtyField = radio.closest('form').querySelector('[name="quantity"]')
            const btn = radio.closest('form').querySelector('button[name="add"]')

            if (!qtyField) return

            qtyField.value = qty

            setTimeout(() => {
                btn.classList.add('animate__animated', 'animate__shakeX')
            }, 250)

            setTimeout(() => {
                btn.classList.remove('animate__animated', 'animate__shakeX')
            }, 1500)
        })
    })
}
initQtyBreaks()

window.addEventListener('variantChange.ecomify.product', async (event) => {
    const wrapper = document.querySelector('#product-qty-breaks')

    if (!wrapper) return

    const respoonse = await fetch(window.location.href)
    const text = await respoonse.text()
    const newDocument = new DOMParser().parseFromString(text, 'text/html')

    document.querySelector('#product-qty-breaks')
        ?.replaceWith(newDocument.querySelector('#product-qty-breaks'))

    initQtyBreaks()
})

/*
    Prev/Next Products (within collection)
*/
const initPrevNextButtons = async () => {
    const wrapper = document.querySelector('#product-prev-next')

    if (!wrapper) return

    if (!window.matchMedia('(max-width: 1599px)').matches) return

    await new Promise(resolve => setTimeout(resolve, 1000))

    const threshold = document.querySelector('#product-content .form-wrapper').getBoundingClientRect().bottom + window.scrollY

    window.addEventListener('scroll', () => {
        if (window.scrollY > threshold) {
            wrapper.classList.add('show')
        } else {
            wrapper.classList.remove('show')
        }
    })
}
initPrevNextButtons()
